import type { FormEvent } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Logo from './Logo';

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setLoading(true);

    // El resultado se ignora a propósito: mostramos siempre el mismo mensaje
    // para no revelar qué correos tienen cuenta.
    await resetPassword(email);

    setLoading(false);
    setSent(true);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-inset">
      <div className="w-full max-w-[360px]">
        {/* Brand */}
        <div className="mb-8 text-center">
          <Logo size={44} className="text-accent mx-auto mb-3" />
          <h2 className="font-serif text-[1.6rem] font-semibold text-accent tracking-tight">
            Legal Hermes
          </h2>
          <p className="text-ink-muted text-[0.8125rem] mt-1.5">Recuperar acceso</p>
        </div>

        {/* Card */}
        <div className="bg-surface-raised rounded-lg p-7 border border-border-emphasis shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
          {sent ? (
            <p className="text-[0.875rem] text-ink-secondary leading-relaxed">
              Si existe una cuenta con ese correo, te enviamos un enlace para restablecer tu
              contraseña.
            </p>
          ) : (
            <form onSubmit={handleSubmit}>
              <p className="text-[0.8125rem] text-ink-muted mb-5 leading-relaxed">
                Ingresa tu correo y te enviaremos un enlace para definir una nueva contraseña.
              </p>

              <div className="mb-6">
                <label
                  className="block mb-1.5 font-medium text-[0.8125rem] text-ink-secondary"
                  htmlFor="email"
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  className="w-full px-3.5 py-2.5 border border-border-emphasis rounded-sm text-[0.875rem] pointer-coarse:text-base font-sans bg-surface-inset text-ink placeholder-ink-muted focus:outline-none focus:border-accent focus:shadow-[0_0_0_3px_rgba(200,150,62,0.1)] transition-[border-color,box-shadow] duration-150"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>

              <button
                type="submit"
                className="w-full px-6 py-2.5 bg-accent text-ink-inverse border-none rounded-sm text-[0.8125rem] font-semibold font-sans inline-flex items-center justify-center gap-2 cursor-pointer transition-[background-color,opacity] duration-150 hover:bg-accent-hover disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'Enviar enlace'}
              </button>
            </form>
          )}

          <div className="mt-5 text-center">
            <Link
              to="/login"
              className="text-[0.75rem] text-ink-muted hover:text-ink-secondary transition-colors duration-150 no-underline"
            >
              ← Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
